import { getI18nJsonProp } from "@/shared/i18n/locales/getI18nJsonProp";
import base from "./base.json";
import fleetAtHome from "./fleet-at-home";
import fleetAtHomeManagement from "./fleet-at-home-management";

export default {
  ...getI18nJsonProp(base, "equivolt"),
  fleetAtHome,
  fleetAtHomeManagement,
};
